import React from "react";

/**
 * Evita schermata beige vuota se un errore React blocca il render dell'albero figlio.
 */
export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("6amico UI error:", error, info);
    // Chunk lazy scaduto dopo un deploy (cache SW): un solo reload recupera il bundle fresco.
    const msg = String(error?.message || error || "");
    if (/ChunkLoadError|Loading chunk|dynamically imported module|Failed to fetch/i.test(msg)) {
      try {
        const last = Number(sessionStorage.getItem("chunk-retry-at") || 0);
        if (Date.now() - last > 30000) {
          sessionStorage.setItem("chunk-retry-at", String(Date.now()));
          window.location.reload();
        }
      } catch {
        window.location.reload();
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.resetKey !== this.props.resetKey && this.state.error) {
      this.setState({ error: null });
    }
  }

  render() {
    if (this.state.error) {
      return (
        <div
          className="min-h-screen flex flex-col items-center justify-center px-6 py-16 bg-parchment text-ink text-center"
          role="alert"
        >
          <h1 className="font-display text-2xl mb-3 notranslate" translate="no">
            Qualcosa non ha caricato correttamente
          </h1>
          <p className="text-sm text-ink2 max-w-md mb-6 notranslate" translate="no">
            Puoi ricaricare la pagina o tornare alla home. Se il problema persiste, prova in una finestra
            privata. La geolocalizzazione non è obbligatoria: puoi continuare anche senza GPS.
          </p>
          <div className="flex flex-wrap gap-3 justify-center notranslate" translate="no">
            <button
              type="button"
              className="rounded-full bg-terracotta text-parchment px-5 py-2.5 text-sm font-medium"
              onClick={() => window.location.reload()}
            >
              Ricarica
            </button>
            <a
              href="/"
              className="rounded-full border border-borderline px-5 py-2.5 text-sm font-medium hover:border-terracotta"
            >
              Vai alla home
            </a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
